<template>
  <div class="items-center w-full px-5">
    <v-card class="mb-4" width="300"> <!-- Adjust width as needed -->
      <v-card-title class="title flex justify-between items-center">
        <span> Filter</span> <!-- Filter title -->
        <div class="spacer"></div> <!-- Spacer -->
        <button @click="clearAllFilters" class="clear-all-button">Clear All</button> <!-- Clear all filters button -->
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-2">
        <!-- Fate dropdown -->
        <div>
          <h6 class="mb-3" @click="toggleOptions('fate')" style="font-size: 1em;">
            <span v-html="arrowIcon('fate')" style="margin-right: 7px;"></span>
            Fate
          </h6>
          <div v-if="showOptions.fate" class="absolute">
            <div class="fate-grid">
              <div v-for="(option, index) in fateOptions" :key="index" class="flex items-center">
                <label class="flex items-center mr-4 checkbox-option">
                  <span class="checkbox">
                    <input type="checkbox" :value="option" v-model="selectedOptions.fate" class="hidden"
                      @change="applyFilter">
                    <span class="checkmark"></span>
                  </span>
                  <span>{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <v-divider class="mt-4"></v-divider>
        <!-- Rank dropdown -->
        <div>
          <h6 class="mb-3" @click="toggleOptions('rank')" style="font-size: 1em;">
            <span v-html="arrowIcon('rank')" style="margin-right: 7px;"></span>
            Rank
          </h6>
          <div v-if="showOptions.rank" class="absolute">
            <div class="rank-grid">
              <div v-for="(option, index) in rankOptions" :key="index" class="flex items-center">
                <label class="flex items-center mr-4 checkbox-option">
                  <span class="checkbox">
                    <input type="checkbox" :value="option" v-model="selectedOptions.rank" class="hidden"
                      @change="applyFilter">
                    <span class="checkmark"></span>
                  </span>
                  <span>{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <v-divider class="mt-4"></v-divider>
        <!-- State dropdown -->
        <div>
          <h6 class="mb-3" @click="toggleOptions('state')" style="font-size: 1em;">
            <span v-html="arrowIcon('state')" style="margin-right: 7px;"></span>
            State
          </h6>
          <div v-if="showOptions.state" class="absolute">
            <div class="state-grid">
              <div v-for="(option, index) in stateOptions" :key="index" class="flex items-center">
                <label class="flex items-center mr-4 checkbox-option">
                  <span class="checkbox">
                    <input type="checkbox" :value="option" v-model="selectedOptions.state" class="hidden"
                      @change="applyFilter">
                    <span class="checkmark"></span>
                  </span>
                  <span>{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <v-divider class="mt-4"></v-divider>
        <!-- Prison dropdown -->
        <div>
          <h6 class="mb-3" @click="toggleOptions('prison')" style="font-size: 1em;">
            <span v-html="arrowIcon('prison')" style="margin-right: 7px;"></span>
            Prison
          </h6>
          <div v-if="showOptions.prison" class="absolute">
            <div class="prison-grid">
              <div v-for="(option, index) in prisonOptions" :key="index" class="flex items-center">
                <label class="flex items-center mr-4 checkbox-option">
                  <span class="checkbox">
                    <input type="checkbox" :value="option" v-model="selectedOptions.prison" class="hidden"
                      @change="applyFilter">
                    <span class="checkmark"></span>
                  </span>
                  <span>{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <v-divider class="mt-4"></v-divider>
        <!-- Company dropdown -->
        <div>
          <h6 class="mb-3" @click="toggleOptions('company')" style="font-size: 1em;">
            <span v-html="arrowIcon('company')" style="margin-right: 7px;"></span>
            Company
          </h6>
          <div v-if="showOptions.company" class="options-container">
            <div class="company-grid">
              <div v-for="(option, index) in companyOptions" :key="index" class="company-option">
                <label class="flex items-center mr-4 checkbox-option">
                  <span class="checkbox">
                    <input type="checkbox" :value="option" v-model="selectedOptions.company" class="hidden"
                      @change="applyFilter">
                    <span class="checkmark"></span>
                  </span>
                  <span>{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <v-divider class="mt-4"></v-divider>
        <!-- Regiment dropdown -->
        <div>
          <h6 class="mb-3" @click="toggleOptions('regiment')" style="font-size: 1em;">
            <span v-html="arrowIcon('regiment')" style="margin-right: 7px;"></span>
            Regiment
          </h6>
          <div v-if="showOptions.regiment" class="absolute">
            <div class="regiment-grid">
              <div v-for="(option, index) in regimentOptions" :key="index" class="regiment-option">
                <label class="flex items-center mr-4 checkbox-option">
                  <span class="checkbox">
                    <input type="checkbox" :value="option" v-model="selectedOptions.regiment" class="hidden"
                      @change="applyFilter">
                    <span class="checkmark"></span>
                  </span>
                  <span>{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      // checkbox options for the side filters
      companyOptions: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "Field and Staff"], // Options for the 'Company' filter
      fateOptions: ["Died", "Lived"], // Options for the 'Fate' filter
      stateOptions: [
        "Iowa Cavalry",
        "Illinois Infantry",
        "Indiana Artillery Battery",
        "Indiana Cavalry",
        "Indiana Infantry",
        "Kentucky Cavalry",
        "Kentucky Infantry",
        "Kentucky Light Artillery",
        "Kentucky Mounted Infantry",
        "Michigan Cavalry",
        "Michigan Engineers & Mechanics",
        "Michigan Infantry",
        "Michigan Light Artillery",
        "Michigan Sharpshooters",
        "New York Infantry",
        "Ohio Cavalry (McLaughlin)",
        "Ohio Cavalry",
        "Ohio Infantry",
        "Ohio Light Artillery",
        "Tennessee Cavalry",
        "Tennessee Infantry",
        "Tennessee Mounted Infantry",
        "United States Colored Troops",
        "Virginia",
        "West Virginia Cavalry",
        "West Virginia Infantry",
        "West Virginia Light Artillery"],
        regimentOptions: ["1", "2", "3", "4", "5", "6", "7", "8", "9",
        "10", "11", "12", "13", "14", "15", "16", "17", "18", "19",
        "20", "21", "22", "33", "24", "25", "26", "27", "28", "29",
        "30", "31", "32", "33", "34", "35", "36", "37", "38",
        "40", "41", "42", "44", "45", "46", "47", "49",
        "50", "51", "52", "53", "54", "55", "57", "58", "59",
        "63", "64", "65", "66", "68",
        "70", "71", "72", "75", "76", "78", "79",
        "80", "81", "82", "83", "84", "85", "86", "88", "89",
        "90 ", "91", "92", "93", "95", "96", "97", "99",
        "100 ", "101", "102", "103", "104",
        "111", "113", "114", "115", "116",
        "121", "122", "124", "125", "129",
        "135", "137",
        "153",
        "175", "178",
        "183"],
        prisonOptions: [
        "Andersonville, GA",
        "Cahaba. AL",
        "City Jail, Eutaw, AL",
        "Macon, GA",
        "Marion, AL",
        "Meridian, MS",
        "Millen, GA",
        "Unknown"],
        rankOptions: [
        "1st Lt", "1st Sgt", "2nd Lt",
        "Artif", "Blksm", "Bugler",
        "Capt", "Comm Sgt", "Cpl",
        "Farrier", "Hos S", "Major",
        "Music", "Prin. Music", "Pvt",
        "QM Sgt", "Saddler", "Sgt", 
        "Sgt Major", "Tmstr", "Vet'y Surgeon", 
        "Wagoner"
        ],

      selectedOptions: {
        company: [], // To store the selected company checkbox values
        fate: [], // To store the selected fate checkbox values
        state: [],
        regiment: [],
        prison: [],
        rank: []
      },
      showOptions: {
        company: false, // To control the display of company options
        fate: false, // To control the display of fate options
        state: false,
        regiment: false,
        prison: false,
        rank: false
      }
    };
  },

  methods: {
    applyFilter() {
      // Filter the people based on selected companies
      const selectedOptions = this.selectedOptions;

      // Filter the 'searchedPeople' array from the main component
      this.$emit('apply-filter', selectedOptions);
    },
    toggleOptions(filter) {
      this.showOptions[filter] = !this.showOptions[filter];
    },
    arrowIcon(filter) {
      return this.showOptions[filter] ? "&#x25BC;" : "&#x25B6;";
    },
    // Method to reset selected filter options
    resetFilters() {
      this.selectedOptions.company = []; // Reset selected company options
      this.selectedOptions.fate = []; // Reset selected fate options
      this.selectedOptions.state = [];
      this.selectedOptions.regiment = [];
      this.selectedOptions.prison = [];
      this.selectedOptions.rank = [];
    },
    clearAllFilters() {
    // Clear all selected options
    this.selectedOptions.company = [];
    this.selectedOptions.fate = [];
    this.selectedOptions.state = [];
    this.selectedOptions.regiment = [];
    this.selectedOptions.prison = [];
    this.selectedOptions.rank = [];

    // // Reset display options
    // this.showOptions.company = false;
    // this.showOptions.fate = false;
    // this.showOptions.state = false;
    // this.showOptions.regiment = false;
    // this.showOptions.prison = false;

    // Emit an event to notify the parent component to undo filtering
    this.$emit('clear-all-filters');
  },
  }
};
</script>
  
<style scoped>
.checkbox {
  position: relative;
  display: inline-block;
  width: 1.2em;
  height: 1.2em;
  margin-right: 0.5em;
  cursor: pointer;
}

.checkbox-option {
  display: flex;
  align-items: flex-start; /* Align items at the start of the flex container (top of the container) */
}

/* Checkmark design */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 1.2em;
  width: 1.2em;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
}

/* Checkmark when checked */
.checkbox input:checked~.checkmark:after {
  content: "";
  position: absolute;
  display: block;
  top: 1px;
  left: 4px;
  width: 6px;
  height: 10px;
  border: solid #000;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}


.absolute {
  width: 10rem;
  /* Adjust the width as needed */

  /* Define grid layout for company options */
}

.company-grid {
  display: grid;
  grid-template-columns: repeat(3, 94px);
  grid-row-gap: 5px;
  /* Adjust vertical gap between rows */
}

.fate-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: 5px;
  /* Adjust vertical gap between rows */
}
.state-grid {
  display: grid;
  grid-template-columns: repeat(2, 130px); /* Adjust the number of columns as needed */
  grid-row-gap: 5px; /* Adjust vertical gap between rows */
  grid-column-gap: 10px;
}

.regiment-grid {
  display: grid;
  grid-template-columns: repeat(4, 70px); /* Adjust the number of columns as needed */
  grid-row-gap: 5px; /* Adjust vertical gap between rows */
  grid-column-gap: 0px;
}

.prison-grid {
  display: grid;
  grid-template-columns: repeat(2, 160px); /* Adjust the number of columns as needed */
  grid-row-gap: 5px; /* Adjust vertical gap between rows */
  grid-column-gap: 0px;
}

.rank-grid {
  display: grid;
  grid-template-columns: repeat(2, 130px); /* Adjust the number of columns as needed */
  grid-row-gap: 5px; /* Adjust vertical gap between rows */
  grid-column-gap: 10px;
}

/* Style for each company option */
.company-option {
  display: flex;
}
.regiment-option {
  display: flex;
}

.spacer {
  width: 30%; /* Expand the spacer to fill the available space */
}
.clear-all-button {
  color: grey;
  text-decoration: underline;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.8em;
}

.clear-all-button:hover {
  color: darkgrey;
}

h6:hover span {
  cursor: pointer;
}
</style>
  